<template>
  <div
    class="n-app-message"
    :class="{
      'n-app-message--left': position === 'left',
      'n-app-message--right': position === 'right',
    }"
  >
    <n-avatar
      size="s"
      :name="message.name"
      :imageUrl="message.avatarUrl"
      v-if="displayAvatar"
      :enableTooltip="enableAvatarTooltip"
      class="n-app-message__avatar"
      :class="{
        'n-app-message__avatar--left': position === 'left',
        'n-app-message__avatar--right': position === 'right',
      }"
    ></n-avatar>
    <n-app
      v-if="card"
      :colour="brandColour"
      :card="card"
      location="conversation"
      :readonly="readonly"
      class="n-app-message__card"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { nanoid } from 'nanoid';
import NApp from '../app/app.vue';
import NAvatar from '../avatar/avatar.vue';
import { AppMessage } from './message';
import { PropType } from 'vue';

const props = defineProps({
  message: {
    type: Object as PropType<AppMessage>,
    required: true,
  },
  brandColour: {
    type: String,
    default: '#062b80',
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
  readonly: {
    type: Boolean,
    default: true,
  },
});

const card = computed(() => {
  if (props.message.card) {
    const { content } = props.message.card;
    return {
      id: props.message.id ? props.message.id : nanoid(),
      content,
    };
  }
  return undefined;
});
</script>

<style lang="scss" scoped>
.n-app-message {
  padding: 0 0.5em;
  max-width: 392px;
  word-wrap: break-word;
  display: flex;
  flex: 1;
  align-items: center;
  margin-bottom: 1rem;
  &--right {
    flex-direction: row-reverse;
  }
  &__avatar {
    flex: 0 0 auto;
    &--left {
      margin-right: 0.5rem;
    }
    &--right {
      margin-left: 0.5rem;
    }
  }
  &__card {
    flex: 1;
  }
}
</style>
